//Creates new Light and assigns ID and type
export const createLight = (data) => {
    //data = {id, type}
    return { type: "CREATE_LIGHT", payload: data}
}


export const lightToggleIsOn = (data) => {
    //data = {id, type}
    return { type: "LIGHT_TOGGLE_ON", payload: data}
}